function Google() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.68 8.18183C15.68 7.61456 15.6291 7.06911 15.5345 6.54547H8V9.64002H12.3055C12.12 10.64 11.5564 11.4873 10.7091 12.0546V14.0618H13.2945C14.8073 12.6691 15.68 10.6182 15.68 8.18183Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99992 16C10.1599 16 11.9708 15.2837 13.2945 14.0618L10.709 12.0546C9.99265 12.5346 9.07629 12.8182 7.99992 12.8182C5.91629 12.8182 4.15265 11.4109 3.52356 9.52002H0.85083V11.5927C2.16719 14.2073 4.87265 16 7.99992 16Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.52364 9.52001C3.36364 9.04001 3.27273 8.52729 3.27273 8.00001C3.27273 7.47274 3.36364 6.96001 3.52364 6.48001V4.40729H0.850909C0.309091 5.48729 0 6.70911 0 8.00001C0 9.29092 0.309091 10.5127 0.850909 11.5927L3.52364 9.52001Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99992 3.18182C9.17447 3.18182 10.229 3.58545 11.0581 4.37818L13.3526 2.08364C11.9672 0.792727 10.1563 0 7.99992 0C4.87265 0 2.16719 1.79273 0.85083 4.40727L3.52356 6.48C4.15265 4.58909 5.91629 3.18182 7.99992 3.18182Z"
        fill="#EA4335"
      />
    </svg>
  );
}

export default Google;
